<template>
  <div class="online-card">
    <div v-if="zhsRole == 2 && newOnlineLink" class="online-link">
      <a :href="newOnlineLink" class="new-path" target="_blank">
        <div class="path-tips">
          <p>新版学堂</p>
          <div class="btn">
            进入
            <span class="arrow-icon"></span>
          </div>
        </div>
      </a>
      <a :href="onlineLink" target="_blank" class="old-path">
        <div class="path-tips">
          <p>旧版学堂</p>
          <div class="btn">
            进入
            <span class="arrow-icon"></span>
          </div>
        </div>
      </a>
    </div>
    <div class="left" v-else>
      <div class="left-on">
        <a :href="onlineLink" target="_blank" class="onlink">{{ $schoolId == 5141 ? 'AI教学中心' :
          '在线学堂' }}
         <img src="@/assets/images/common/more-icon.png" alt="" class="icon"/></a>
      </div>

      <!-- <span class="title">{{ $schoolId == 5141 ? 'AI教学中心' : '在线学堂'}}</span> -->
      <!--    <a :href="onlineLink" target="_blank" class="online-link">进入 ></a> -->
    </div>
  </div>
</template>

<script setup>
defineProps({
  onlineLink: String,
  zhsRole: Number
})

const $http = inject('$http')
const newOnlineLink = ref('')

const getNewOnlineLink = async () => {
  const res = await $http.getNewOnlineCourseUrl()
  newOnlineLink.value = res
}
getNewOnlineLink()
</script>

<style lang="scss" scoped>
.left-on {
  background: #1546F2;
  border-radius: 8px 8px 8px 8px;
  justify-content: center;
  width: 119px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 27%;
  margin-left: 11px;
  .icon{
    height: 15px;
    width: 15px;
  //  / margin-top: 4px;
  }
}

.onlink {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 22px;


}

.online-card {
  // padding-top: 100px;
  width: 96%;
  margin-left: 2%;
  padding: 8px 0;
  display: flex;
  align-items: center;

  .online-link {
    position: relative;
    width: 306px;
    height: 130px;
    display: flex;
    justify-content: flex-start;

    .new-path {
      flex: 1;
      height: 100%;
      background: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/0d18a8217b1a47f08dbe55d19e836088.png') no-repeat;
      background-size: cover;
      cursor: pointer;
      -webkit-clip-path: polygon(100% 100%, 100% 0, 14px 0, 0 100%);
      clip-path: polygon(100% 100%, 100% 0, 14px 0, 0 100%);
      transform: rotate(180deg);
      border-radius: 0 12px 12px 0;

      .path-tips {
        transform: rotate(180deg);
        padding-left: 25px;
      }
    }

    .old-path {
      flex: 1;
      height: 100%;
      background: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/c2adb72ba5a64af8a53cd6446c8f6c64.png') no-repeat;
      background-size: cover;
      cursor: pointer;
      -webkit-clip-path: polygon(100% 100%, 100% 0, 14px 0, 0 100%);
      clip-path: polygon(100% 100%, 100% 0, 14px 0, 0 100%);
      border-radius: 0 12px 12px 0;

      .path-tips {
        padding-left: 30px;
      }
    }

    .path-tips {
      height: 100%;
      padding: 16px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-weight: 600;
      font-size: 16px;
      color: #fff;

      .btn {
        width: 54px;
        height: 19px;
        background: #fff;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 12px;
        color: #333;
        padding: 0 8px;

        .arrow-icon {
          width: 10px;
          height: 11px;
          background: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/6512346f748a47269a2f49532138d003.png') no-repeat;
          background-size: cover;
        }

        &:hover {
          background-color: $--color-primary;
          color: #fff;

          .arrow-icon {
            background: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202410/8d618ef7155e432289294906249856d7.png') no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }

  .left {
    width: 100%;
    height: 160px;
    // margin-top: 19%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url('https://image.zhihuishu.com/zhs/b2cm/base1/202506/434797072f2e471cbca2a5ba8caa4b41.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 16px;

    .title {
      color: #fff;
      font-size: 25px;
      font-family: PingFang SC-中粗体, PingFang SC;
      margin-bottom: 55px;
    }

    .online-link {
      color: #fff;
      font-size: 15px;
      cursor: pointer;
    }
  }
}
</style>
